import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = 'QUIERO MIS CLASES RESUELTAS',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://checkout.ebookbtnlines.shop/cart/45530178650159:1" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`block w-full max-w-md mx-auto bg-teal-700 text-white font-bold text-center py-4 px-6 rounded-full shadow-lg hover:bg-teal-800 hover:shadow-xl transition-all uppercase tracking-wide text-sm sm:text-base whitespace-nowrap ${className}`} data-id="element-147" data-mp="2kzg0lg5d0yhx">
      {text}
    </motion.a>;
}